// Admin-side employee management (employee-service). Lets HR/admins edit the
// HR-managed fields (National ID, NSSF, TIN, position, department, level, manager,
// status) that employees can't change themselves.
import axios from 'axios';

// Route through the API gateway (auth, rate-limit, audit, entitlement) rather than
// calling employee-service directly. The gateway maps /api/v1/employees and
// /api/v1/departments to employee-service (server.js ROUTES). (P0-4)
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

function authHeader() {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface AdminEmployee {
  id: string;
  employee_id?: string;
  first_name?: string;
  last_name?: string;
  email: string;
  phone?: string | null;
  position?: string;
  org_level?: string;
  status?: string;
  department_id?: string | null;
  manager_id?: string | null;
  national_id?: string | null;
  nssf?: string | null;
  tin?: string | null;
  [k: string]: any;
}

export interface Paged<T> { items: T[]; total: number; page: number; page_size: number; total_pages: number; }

export async function getEmployees(params: { page?: number; page_size?: number; query?: string } = {}): Promise<Paged<AdminEmployee>> {
  const { data } = await axios.get(`${API_URL}/employees/`, { headers: authHeader(), params });
  return data;
}

export async function getDepartments(): Promise<{ id: string; name: string }[]> {
  const { data } = await axios.get(`${API_URL}/departments/`, { headers: authHeader(), params: { page: 1, page_size: 100 } });
  return data.items || [];
}

export async function updateEmployee(id: string, payload: Partial<AdminEmployee>): Promise<AdminEmployee> {
  const { data } = await axios.put(`${API_URL}/employees/${id}`, payload, { headers: authHeader() });
  return data;
}

export const ORG_LEVELS = ['employee', 'manager', 'director', 'executive', 'ceo'];
export const STATUSES = ['Active', 'Inactive', 'OnLeave', 'Terminated'];
